import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DashboardWrapper from "../../../components/DashboardWrapper";
import CrudForm from "../../../components/dashboard/form/CrudForm";
import { useCrud } from "../../../hooks/useCrud";

export default function CreateBanner() {
  const navigate = useNavigate();
  const { createItem } = useCrud("backend/banners", ["banner"]);
  const [loading, setLoading] = useState(false);

  const allowedFields = [
    "banner",
    "banner_title",
    "banner_content",
    "starting_price",
    // "serial",
    "status",
  ];

  const initialData = allowedFields.reduce((acc, field) => {
    acc[field] = field === "status" ? 1 : "";
    return acc;
  }, {});

  const handleSubmit = useCallback(
    async (formData) => {
      try {
        setLoading(true);
        console.log("Submitting formData:", formData);

        const formPayload = new FormData();

        allowedFields.forEach((field) => {
          if (field === "banner") {
            const bannerValue = formData.banner;
            if (bannerValue) {
              // Handle both single File and array of Files
              if (Array.isArray(bannerValue)) {
                bannerValue.forEach((file) =>
                  formPayload.append("banner[]", file)
                );
              } else {
                formPayload.append("banner", bannerValue);
              }
            }
          } else {
            formPayload.append(field, formData[field]);
          }
        });

        // Send request to backend
        await createItem(formPayload);

        Swal.fire({
          title: "Success",
          text: "Banner created successfully!",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#FB6C22",
        });
        navigate("/admin/sliders");
      } catch (error) {
        console.error("Create banner error:", error);
        const errorMessage =
          error.response?.data?.errors
            ? Object.values(error.response.data.errors).flat().join(", ")
            : error.response?.data?.message || "Failed to create banner";
        Swal.fire("Error", errorMessage, "error");
      } finally {
        setLoading(false);
      }
    },
    [createItem, navigate]
  );

  return (
    <DashboardWrapper>
      <div className="p-4">
        <h1 className="h4">Create Banner</h1>

        <div className="d-flex justify-content-between align-items-center mb-4">
          <button
            className="btn btn-secondary d-flex align-items-center justify-content-between"
            onClick={() => navigate(-1)}
          >
            <span>Back</span>
          </button>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <h5 className="card-header">Create Banner</h5>
              <div className="card-body demo-vertical-spacing demo-only-element">
                {!loading ? (
                  <CrudForm
                    initialData={initialData}
                    onSubmit={handleSubmit}
                    allowedFields={allowedFields}
                    fileFields={[{ name: "banner", multiple: false }]}
                  />
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
